import {Button} from '@kit';

import React from 'react';

import {useCharacterSheetsQuery} from '../../generated/types';
import {Link} from '../../lib/routes';
import {SheetSummary, useTitleLookups} from '../sheets/sheet-summary';

import css from './my-sheets.module.css';

const LIMIT = 3;

export const MySheets: React.FC = () => {
	const {data} = useCharacterSheetsQuery({ssr: false, fetchPolicy: 'cache-and-network'});
	const titles = useTitleLookups();
	const sheets = [...(data?.characterSheets || [])]
		.sort((first, second) => second.updatedAt.localeCompare(first.updatedAt))
		.slice(0, LIMIT);

	return (
		<section className={css.block} aria-labelledby="home-my-sheets">
			<div className={css.header}>
				<h2 id="home-my-sheets" className={css.title}>
					Мои бланки персонажей
				</h2>
				<Button link route="sheets">
					{sheets.length ? 'Все бланки' : 'Создать бланк'}
				</Button>
			</div>
			{data && !sheets.length ? (
				<p className={css.empty}>
					У вас пока нет персонажей. Бланк создаётся за несколько шагов, а считает за вас всё остальное.
				</p>
			) : (
				<ul className={css.list}>
					{sheets.map((sheet) => (
						<li key={sheet.id}>
							<Link route="sheet" params={{id: sheet.id}} className={css.sheet}>
								<span className={css.name}>{sheet.name || 'Безымянный персонаж'}</span>
								<SheetSummary sheet={sheet} titles={titles} />
							</Link>
						</li>
					))}
					<li>
						<Button route="sheets">
							Новый персонаж
						</Button>
					</li>
				</ul>
			)}
		</section>
	);
};
